import { combineReducers } from 'redux';
import DashboardReducer from "./dashboardReducer";
import AuthReducer from "./AuthReducer";
import reportsReducer from "./reportReducer";
import CommonReducer from "./commonReducer";
import instrumentListReducer from "./instrumentListReducer";
import activityReducer from "./activityReducer";
import newsFeedReducer from "./newsFeedReducer";
import changePasswordReducer from "./changePasswordReducer";
import chartReducer from "./chartReducer";
import outstandingOrderReducer from "./outstandingOrderReducer";
import paymentReducer from "./paymentReducer";
import swapRateReducer from "./swapRateReducer";
import tradepanelReducer from './tradepanelReducer';

import { push } from 'react-router-redux';

const appReducer = combineReducers({
  auth: AuthReducer,
  reportsReducer: reportsReducer,
  dashboardReducer:DashboardReducer,
  commonReducer:CommonReducer,
  instrumentListReducer,
  activityReducer,
  newsFeedReducer,
  changePasswordReducer,
  chartReducer,
  outstandingOrderReducer,
  paymentReducer,
  swapRateReducer,
  tradepanelReducer
});
const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    state = undefined
  }
  return appReducer(state, action)
}
export default rootReducer;
